import {memo, useEffect, useRef} from 'react';
import toast from '@/components/HotToast';
import {AnalysisItem} from '@/map/@types';
import {useFootTraffic} from '@/map/api/analytics/foot-traffic';
import {MAX_VISIBLE_ZOOM_METER, MESSAGES} from '@/map/constants';
import {useVisibleZoomLevel} from '@/map/hooks';
import {getIntlString} from '@/utils';
import {FootTrafficTile} from './Tile';

interface IProps {
  map: naver.maps.Map;
  item: AnalysisItem;
}

export const FootTrafficTileLayer = memo(({map, item}: IProps) => {
  const {data} = useFootTraffic(item, item.footTraffic?.vars);

  const showTile = item.footTraffic?.showTile;

  const toastId = useRef<string>();
  const isAvailableLevel = useVisibleZoomLevel(MAX_VISIBLE_ZOOM_METER.tile);

  useEffect(() => {
    if (showTile && !isAvailableLevel) {
      toastId.current = toast(
        getIntlString(MESSAGES, 'area-analytics-zoom-warning', {
          type: '유동인구를',
        }),
        {duration: Infinity}
      );
    } else if (toastId?.current) {
      toast.dismiss(toastId.current);
      toastId.current = undefined;
    }
  }, [isAvailableLevel, showTile]);

  useEffect(() => {
    return () => {
      if (toastId?.current) {
        toast.dismiss(toastId.current);
        toastId.current = undefined;
      }
    };
  }, []);

  if (!map || !showTile || !data?.result?.length) {
    return null;
  }

  return (
    <>
      {data.result.map(
        (i, idx) =>
          !!i.tilePolygon && <FootTrafficTile key={idx} map={map} item={i} />
      )}
    </>
  );
});
